import Vue from 'vue'
const Iframe = {
  install: (Vue) => {
    const iframe = new Vue({
      data: {
        iframe: {
          width: '480px',
          height: '600px',
          scrolling: 'no',
          redirectUrl: null,
          backUrl: null
        }
      }
    })
    Vue.prototype.$iframe = iframe
  }
}
Vue.use(Iframe)

window.addEventListener('message', function (e) {
    if (e.data.event === 'close-iframe-message') {
      if (e.data.message) {
        window.location.replace(e.data.message)
      }
      Vue.prototype.$iframe.iframe.redirectUrl = null
    }
})
